package pwgs.ui.scenes.acceptinvitationscene


class AcceptInvitationControllerFe(props: AcceptInvitationSceneProps, scene: MAcceptInvitationScene) : AAcceptInvitationControllerFe(props, scene) {

    override fun createInitialModel() : AcceptInvitationSceneModel {
        return AcceptInvitationSceneModel()
    }

    override fun init() {
        call_load()
    }


}

